import React from "react";

export function PctInput({ testid, pct, onChange, className = "" }) {
  const [txt, setTxt] = React.useState(String(Math.round(pct * 100)));
  React.useEffect(() => { setTxt(String(Math.round(pct * 100))); }, [pct]);
  const commit = () => {
    const v = Math.min(100, Math.max(0, Math.round(Number(txt) || 0)));
    setTxt(String(v));
    if (v / 100 !== pct) onChange(v / 100);
  };
  return (
    <input data-testid={testid} type="number" min="0" max="100" step="5" className={className}
      value={txt} onChange={(e) => setTxt(e.target.value)} onBlur={commit}
      onKeyDown={(e) => { if (e.key === "Enter") e.currentTarget.blur(); }} />
  );
}
